<template>
  <div>

    <b-modal id="modal-matriz" ref="my-modal-matriz" :ok-title="btnGrabarMatriz" cancel-title="Cerrar" centered
             size="lg" :title="titleModalMatriz" @show="resetModalMatriz" @hidden="resetModalMatriz"
             @ok="handleOkMatriz">

      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>

            <b-col md="6">
              <b-form-group>
                <label>Categoria</label>
                <validation-provider #default="{ errors }" rules="required" name="Categoria">
                  <b-form-select v-model="selectedCategoriaGuardar"
                                 :state="errors.length > 0 ? false:null" :options="optionsCategoriaGuardar"
                                 v-on:change="mostrarSubCategoriaGuardar()" />
                  <small class="text-danger" v-if="errors[0]">El campo Categoria es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Sub Categoria</label>
                <validation-provider #default="{ errors }" rules="required" name="Sub Categoria">
                  <b-form-select v-model="selectedSubCategoriaGuardar"
                                 :state="errors.length > 0 ? false:null" :options="optionsSubCategoriaGuardar" />
                  <small class="text-danger" v-if="errors[0]">El campo Sub Categoria es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>N° Articulo</label>
                <validation-provider #default="{ errors }" rules="required" name="N° Articulo">
                  <b-form-input v-model="nro_articulo" :state="errors.length > 0 ? false:null"
                                placeholder="N° Articulo" />
                  <small class="text-danger" v-if="errors[0]">El campo N° Articulo es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Articulo</label>
                <validation-provider #default="{ errors }" rules="required" name="Articulo">
                  <b-form-input v-model="articulo" :state="errors.length > 0 ? false:null"
                                placeholder="Articulo" />
                  <small class="text-danger" v-if="errors[0]">El campo Articulo es obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>N° Inciso</label>
                <validation-provider #default="{ errors }" rules="required" name="N° Inciso">
                  <b-form-input v-model="nro_inciso" :state="errors.length > 0 ? false:null"
                                placeholder="N° Inciso" />
                  <small class="text-danger" v-if="errors[0]">El campo N° Inciso es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Inciso</label>
                <validation-provider #default="{ errors }" rules="required" name="Inciso">
                  <b-form-input v-model="inciso" :state="errors.length > 0 ? false:null"
                                placeholder="Inciso" />
                  <small class="text-danger" v-if="errors[0]">El campo Inciso es obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group>
                <label>Supuesto</label>
                <validation-provider #default="{ errors }" rules="required" name="Supuesto">
                  <b-form-input v-model="supuesto" :state="errors.length > 0 ? false:null"
                                placeholder="Supuesto" />
                  <small class="text-danger" v-if="errors[0]">El campo Supuesto es obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Estado Matriz</label>
                <validation-provider #default="{ errors }" rules="required" name="Estado Matriz">
                  <b-form-input v-model="estado_matriz" :state="errors.length > 0 ? false:null"
                                placeholder="Estado Matriz" />
                  <small class="text-danger" v-if="errors[0]">El campo Estado Matriz es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Gravedad</label>
                <validation-provider #default="{ errors }" rules="required" name="Tipo">
                  <b-form-input v-model="tipo" :state="errors.length > 0 ? false:null"
                                placeholder="Gravedad" />
                  <small class="text-danger" v-if="errors[0]">El campo Gravedad es obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Tipo Sancion | Gradualidad 1</label>
                <validation-provider #default="{ errors }" rules="required"
                                     name="Tipo Sancion | Gradualidad 1">
                  <b-form-select v-model="selected_tipo_sancion_1"
                                 :state="errors.length > 0 ? false:null" :options="optionsTipoEstado"
                                 v-on:change="mostrarcant1()" />
                  <small class="text-danger" v-if="errors[0]">El campo Tipo Sancion | Gradualidad 1 es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Cant. Días | Gradualidad 1</label>
                <validation-provider #default="{ errors }" rules="required|integer"
                                     name="Cant. Días | Gradualidad 1">
                  <b-form-input v-model="cant_dias_1" :disabled="disabled_cant_dias_1"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Cant. Días | Gradualidad 1" />
                  <small class="text-danger" v-if="errors[0]">El campo Cant. Días | Gradualidad 1 es
                    obligatorio y debe ser un número entero</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Tipo Sancion | Gradualidad 2</label>
                <validation-provider #default="{ errors }" rules="required"
                                     name="Tipo Sancion | Gradualidad 2">
                  <b-form-select v-model="selected_tipo_sancion_2"
                                 :state="errors.length > 0 ? false:null" :options="optionsTipoEstado"
                                 v-on:change="mostrarcant2()" />
                  <small class="text-danger" v-if="errors[0]">El campo Tipo Sancion | Gradualidad 2 es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Cant. Días | Gradualidad 2</label>
                <validation-provider #default="{ errors }" rules="required|integer"
                                     name="Cant. Días | Gradualidad 2">
                  <b-form-input v-model="cant_dias_2" :disabled="disabled_cant_dias_2"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Cant. Días | Gradualidad 2" />
                  <small class="text-danger" v-if="errors[0]">El campo Cant. Días | Gradualidad 2 es
                    obligatorio y debe ser un número entero</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Tipo Sancion | Gradualidad 3</label>
                <validation-provider #default="{ errors }" rules="required"
                                     name="Tipo Sancion | Gradualidad 3">
                  <b-form-select v-model="selected_tipo_sancion_3"
                                 :state="errors.length > 0 ? false:null" :options="optionsTipoEstado"
                                 v-on:change="mostrarcant3()" />
                  <small class="text-danger" v-if="errors[0]">El campo Tipo Sancion | Gradualidad 3 es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Cant. Días | Gradualidad 3</label>
                <validation-provider #default="{ errors }" rules="required|integer"
                                     name="Cant. Días | Gradualidad 3">
                  <b-form-input v-model="cant_dias_3" :disabled="disabled_cant_dias_3"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Cant. Días | Gradualidad 3" />
                  <small class="text-danger" v-if="errors[0]">El campo Cant. Días | Gradualidad 3 es
                    obligatorio y debe ser un número entero</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Tipo Sancion | Gradualidad 4</label>
                <validation-provider #default="{ errors }" rules="required"
                                     name="Tipo Sancion | Gradualidad 4">
                  <b-form-select v-model="selected_tipo_sancion_4"
                                 :state="errors.length > 0 ? false:null" :options="optionsTipoEstado"
                                 v-on:change="mostrarcant4()" />
                  <small class="text-danger" v-if="errors[0]">El campo Tipo Sancion | Gradualidad 4 es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Cant. Días | Gradualidad 4</label>
                <validation-provider #default="{ errors }" rules="required|integer"
                                     name="Cant. Días | Gradualidad 4">
                  <b-form-input v-model="cant_dias_4" :disabled="disabled_cant_dias_4"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Cant. Días | Gradualidad 4" />
                  <small class="text-danger" v-if="errors[0]">El campo Cant. Días | Gradualidad 4 es
                    obligatorio y debe ser un número entero</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Medios Probatorios</label>
                <validation-provider #default="{ errors }" rules="required" name="Medios Probatorios">
                  <b-form-input v-model="medios_probatorios" :state="errors.length > 0 ? false:null"
                                placeholder="Medios Probatorios" />
                  <small class="text-danger" v-if="errors[0]">El campo Medios Probatorios es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Observación</label>
                <validation-provider #default="{ errors }" rules="required" name="Observación">
                  <b-form-input v-model="observacion" :state="errors.length > 0 ? false:null"
                                placeholder="Observación" />
                  <small class="text-danger" v-if="errors[0]">El campo Observación es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label>Responsable</label>
                <validation-provider #default="{ errors }" rules="required" name="Responsable">
                  <b-form-input v-model="responsable" :state="errors.length > 0 ? false:null"
                                placeholder="Responsable" />
                  <small class="text-danger" v-if="errors[0]">El campo Responsable es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

    </b-modal>

    <div class="row">
      <div class="col-md-12 co-12">
        <b-card title="Busqueda">

          <b-row>

            <b-col md="6" xl="4">
              <b-form-group label="Categoria" label-for="categoria">
                <b-form-select v-model="selectedCategoria" :options="optionsCategoria"
                               v-on:change="mostrarSubCategoriaFiltro()" />
              </b-form-group>
            </b-col>

            <b-col md="6" xl="4">
              <b-form-group label="Sub Categoria" label-for="subcategoria">
                <b-form-select v-model="selectedSubCategoria" :options="optionsSubCategoria" />
              </b-form-group>
            </b-col>

            <b-col md="6" xl="4">
              <div class="demo-inline-spacing">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                          v-on:click="obtenerMatriz()">
                  Filtrar
                </b-button>
              </div>
            </b-col>


          </b-row>

        </b-card>
      </div>

      <div class="col-md-12 co-12">

        <b-card title="Lista de Matriz">

          <b-row>
            <b-col md="6" sm="6" class="my-1">
              <div class="demo-inline-spacing">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          v-on:click="modalCrearMatrizIndividual()" size="sm" variant="primary">
                  Nuevo
                </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" v-on:click="descargarCategoriasSubCategorias()"
                          size="sm" variant="warning">
                  Exportar Matriz
                </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" v-on:click="subidaMasivaMatriz()"
                          size="sm" variant="warning">
                  Subir Matriz de sanciones
                </b-button>
              </div>
            </b-col>

            <b-col md="6" class="my-1">
              <b-form-group label="Buscar" label-cols-sm="3" label-align-sm="right" label-size="sm"
                            label-for="filterInput" class="mb-0">
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" type="search"
                                placeholder="Escribe para buscar" />
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col cols="12">
              <b-table ref="selectableTable" selectable small="small" responsive :per-page="perPage"
                       :current-page="currentPage" :items="matriz" :fields="fieldsMatriz"
                       :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                       :filter="filter" :filter-included-fields="filterOn" @filtered="onFilteredMatriz"
                       :select-mode="selectModeMatriz" @row-selected="onRowMatrizSelected"
                       :busy="cargandoMatriz" show-empty>

                <template #empty="scope">
                  <div role="alert" aria-live="polite">
                    <div class="text-center my-2">No hay registros para mostrar</div>
                  </div>
                </template>
                <template #emptyfiltered="scope">
                  <div role="alert" aria-live="polite">
                    <div class="text-center my-2">No hay registros que coincidan con su solicitud
                    </div>
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-dark my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                  </div>
                </template>

                <template #cell(id)="data">
                  <b-input-group-append>
                    <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-success"
                              class="btn-icon" v-on:click="modalEditarMatrizIndividual(data.value)">
                      <feather-icon icon="Edit2Icon" />
                    </b-button>
                    <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger"
                              class="btn-icon" v-on:click="eliminarMatriz(data.value)">
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-input-group-append>
                </template>

              </b-table>
            </b-col>

            <b-col md="7" sm="8" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">Por Página</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"
                               class="w-50" />
              </b-form-group>
            </b-col>

            <b-col md="5" class="my-1">
              <b-pagination v-model="currentPage" :total-rows="totalRowsMatriz" :per-page="perPage"
                            align="center" size="sm" class="my-0" />
            </b-col>
          </b-row>

        </b-card>

      </div>
    </div>
  </div>
</template>

<script>
import axiosIns from '../../../libs/axios'

import {
  BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, BFormDatepicker,
  BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
  BSpinner, BForm
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import moment from 'moment'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Swal from 'sweetalert2'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, Cleave, BFormDatepicker,
    BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
    BSpinner, BForm, Swal
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      matrizIdEditar: null,

      nro_articulo: '',
      articulo: '',
      nro_inciso: '',
      inciso: '',
      supuesto: '',
      estado_matriz: '',
      tipo: '',
      tipoEstado: [],
      optionsTipoEstado: [],
      selected_tipo_sancion_1: '',
      cant_dias_1: '',
      selected_tipo_sancion_2: '',
      cant_dias_2: '',
      selected_tipo_sancion_3: '',
      cant_dias_3: '',
      selected_tipo_sancion_4: '',
      cant_dias_4: '',
      medios_probatorios: '',
      observacion: '',
      responsable: '',
      categoria: '',
      subcategoria: '',

      //////////////


      required,

      cargandoMatriz: false,

      selectedCategoria: 'TODAS',
      optionsCategoria: [],

      selectedSubCategoria: 'TODAS',
      optionsSubCategoria: [],

      subcategorias: [],

      selectedCategoriaGuardar: null,
      optionsCategoriaGuardar: [],

      selectedSubCategoriaGuardar: null,
      optionsSubCategoriaGuardar: [],

      filter: null,
      filterOn: [],
      perPage: 5,
      currentPage: 1,
      matriz: [],
      fieldsMatriz: [
        { key: 'id', label: 'Opciones', sortable: true, stickyColumn: true, isRowHeader: true },
        { key: 'nro_articulo', label: 'N° articulo', sortable: true },
        { key: 'articulo', label: 'Articulo', sortable: true },
        { key: 'descripcion_categoria', label: 'Categoria', sortable: true },
        { key: 'descripcion_sub_categoria', label: 'Sub Categoria', sortable: true },
        { key: 'nro_inciso', label: 'N° inciso', sortable: true },
        { key: 'inciso', label: 'Inciso', sortable: true },
        { key: 'supuesto', label: 'Supuesto', sortable: true },
        { key: 'estado_matriz', label: 'Estado Mmatriz', sortable: true },
        { key: 'tipo', label: 'Gravedad', sortable: true },
        { key: 'descripcion_tipo_sancion_1', label: 'Gradualidad 1', sortable: true },
        { key: 'descripcion_tipo_sancion_2', label: 'Gradualidad 2', sortable: true },
        { key: 'descripcion_tipo_sancion_3', label: 'Gradualidad 3', sortable: true },
        { key: 'descripcion_tipo_sancion_4', label: 'Gradualidad 4', sortable: true },
        { key: 'medios_probatorios', label: 'Medios Probatorios', sortable: true },
        { key: 'observacion', label: 'Observacion', sortable: true },
        { key: 'responsable', label: 'Responsable', sortable: true },
      ],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      selectModeMatriz: 'single',
      pageOptions: [3, 5, 10],
      totalRowsMatriz: 1,

      btnGrabarMatriz: "",
      titleModalMatriz: "",

      disabled_cant_dias_1: false,
      disabled_cant_dias_2: false,
      disabled_cant_dias_3: false,
      disabled_cant_dias_4: false,

      idMatrizEliminar: false,


    }
  },
  methods: {
    descargarCategoriasSubCategorias() {

      var config = {
        method: 'post',
        url: '/sap/md/mdmatriz/descargarexcel/',
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              console.log(fileURL);
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "matriz de sanciones.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          })
          .catch((error) => {
            console.log(error);
          });

    },
    obtenerCategorias() {
      this.optionsCategoria = [];
      this.selectedCategoria = "TODAS";

      const config = {
        method: 'get',
        url: '/sap/md/categoria/list/',
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              let optionsTemporal = response.data;
              this.optionsCategoria.push({ value: 'TODAS', text: 'TODAS' });

              optionsTemporal.filter((item) => {
                this.optionsCategoria.push({ value: item.id, text: item.descripcion });
                this.optionsCategoriaGuardar.push({ value: item.id, text: item.descripcion });
              });

              //console.log(response.data);

              this.obtenerSubCategorias();

              //this.optionsCategoria = arrayCategoria;
              //this.optionsCategoriaGuardar = arrayCategoria;

            }
            //console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            // this.obtenerCategorias();
          });
    },
    obtenerSubCategorias() {
      this.subcategorias = []
      /*this.optionsSubCategoria = [];
      const arraySubCategoria = [];*/

      const config = {
        method: 'get',
        url: '/sap/md/subcategoria/list/',
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.subcategorias = response.data;
            }
            this.mostrarSubCategoriaFiltro();
            //console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            // this.obtenerSubCategorias();
          });
    },
    obtenerTipoEstado() {
      this.tipoEstado = [];
      this.optionsTipoEstado = [];

      const config = {
        method: 'get',
        url: '/sap/md/mdtiposancion/list/',
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.tipoEstado = response.data;
              let optionsTemporal = response.data;

              optionsTemporal.filter((item) => {
                this.optionsTipoEstado.push({ value: item.id, text: item.descripcion });
              });

              //console.log(this.optionsTipoEstado);
              //this.optionsCategoriaGuardar = arrayCategoria;

            }
            //console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            // this.obtenerTipoEstado();
          });
    },
    onFilteredMatriz(filteredItems) {
      console.log(filteredItems.length);
      this.totalRowsMatriz = filteredItems.length;
      this.currentPage = 1
    },
    onRowMatrizSelected(items) {

      //this.$router.push('/saciones-gestionar-meddisciplinarias-page/' + items[0]["id"]);
    },
    obtenerMatriz() {

      this.cargandoMatriz = true;
      this.matriz = [];

      var FormData = require('form-data');
      var data = new FormData();
      data.append('categoria_id', this.selectedCategoria);
      data.append('subcategoria_id', this.selectedSubCategoria);

      var config = {
        method: 'post',
        url: '/sap/md/mdmatriz/listxfiltro/',
        data: data
      };

      axiosIns(config)
          .then((response) => {
            //console.log(JSON.stringify(response.data.response));
            //return response.data.response;
            if (response.status === 200) {
              this.matriz = response.data.response;
              this.totalRowsMatriz = this.matriz.length;
            }
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            // this.obtenerMatriz();
          })
          .finally(() => {
            this.cargandoMatriz = false;
          });

    },
    modalCrearMatrizIndividual() {
      this.matrizI = [];
      this.titleModalMatriz = "Crear Matriz";
      this.btnGrabarMatriz = "Crear";
      this.matrizIdEditar = null;

      this.selectedCategoriaGuardar = null;
      this.mostrarSubCategoriaGuardar();
      this.selectedSubCategoriaGuardar = null;

      this.nro_articulo = null;
      this.articulo = null;
      this.nro_inciso = null;
      this.inciso = null;
      this.supuesto = null;
      this.estado_matriz = null;
      this.tipo = null;
      this.selected_tipo_sancion_1 = null;
      this.mostrarcant1();
      this.cant_dias_1 = null;

      this.selected_tipo_sancion_2 = null;
      this.mostrarcant2();
      this.cant_dias_2 = null;

      this.selected_tipo_sancion_3 = null;
      this.mostrarcant3();
      this.cant_dias_3 = null;

      this.selected_tipo_sancion_4 = null;
      this.mostrarcant4();
      this.cant_dias_4 = null;

      this.medios_probatorios = null;
      this.observacion = null;
      this.responsable = null;

      this.$refs['my-modal-matriz'].show();


    },
    modalEditarMatrizIndividual(id) {
      this.matrizI = [];
      this.titleModalMatriz = "Editar Matriz";
      this.btnGrabarMatriz = "Editar";
      this.matrizIdEditar = id;
      //this.subcategoria = await detalleSubCategoria(this.idSubCategoria);

      var config = {
        method: 'get',
        url: '/sap/md/mdmatriz/detalle/' + this.matrizIdEditar,
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.matrizI = response.data;

              this.selectedCategoriaGuardar = this.matrizI.categoria;
              this.mostrarSubCategoriaGuardar();
              this.selectedSubCategoriaGuardar = this.matrizI.subcategoria;

              this.nro_articulo = this.matrizI.nro_articulo;
              this.articulo = this.matrizI.articulo;
              this.nro_inciso = this.matrizI.nro_inciso;
              this.inciso = this.matrizI.inciso;
              this.supuesto = this.matrizI.supuesto;
              this.estado_matriz = this.matrizI.estado_matriz;
              this.tipo = this.matrizI.tipo;
              this.selected_tipo_sancion_1 = this.matrizI.tipo_sancion_1;
              this.mostrarcant1();
              this.cant_dias_1 = this.matrizI.cant_dias_1;

              this.selected_tipo_sancion_2 = this.matrizI.tipo_sancion_2;
              this.mostrarcant2();
              this.cant_dias_2 = this.matrizI.cant_dias_2;

              this.selected_tipo_sancion_3 = this.matrizI.tipo_sancion_3;
              this.mostrarcant3();
              this.cant_dias_3 = this.matrizI.cant_dias_3;

              this.selected_tipo_sancion_4 = this.matrizI.tipo_sancion_4;
              this.mostrarcant4();
              this.cant_dias_4 = this.matrizI.cant_dias_4;

              this.medios_probatorios = this.matrizI.medios_probatorios;
              this.observacion = this.matrizI.observacion;
              this.responsable = this.matrizI.responsable;


              //this.descripcionSubCategoria = this.subcategoria.descripcion;

              this.$refs['my-modal-matriz'].show();
              //console.log(this.matrizI);
            }
          })
          .catch((error) => {
            //console.log(error);
            //return false;
          });


    },
    resetModalMatriz() {
      /*this.descripcion = ''
      this.descripcionStateCategoria = null*/
    },
    handleOkMatriz(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          if (this.matrizIdEditar != null) {
            this.editarMatriz();
          } else {
            this.crearMatriz();
          }
        }
      })
      /*bvModalEvt.preventDefault()
      this.handleSubmitMatriz()*/
    },
    crearMatriz() {

      var fechaActual = moment().format('YYYY-MM-DD H:mm:ss');

      var data = {
        "categoria": this.selectedCategoriaGuardar,
        "subcategoria": this.selectedSubCategoriaGuardar,
        "nro_articulo": this.nro_articulo,
        "articulo": this.articulo,
        "inciso": this.inciso,
        "nro_inciso": this.nro_inciso,
        "supuesto": this.supuesto,
        "estado_matriz": this.estado_matriz,
        "tipo": this.tipo,
        "tipo_sancion_1": this.selected_tipo_sancion_1,
        "cant_dias_1": this.cant_dias_1,
        "tipo_sancion_2": this.selected_tipo_sancion_2,
        "cant_dias_2": this.cant_dias_2,
        "tipo_sancion_3": this.selected_tipo_sancion_3,
        "cant_dias_3": this.cant_dias_3,
        "tipo_sancion_4": this.selected_tipo_sancion_4,
        "cant_dias_4": this.cant_dias_4,
        "medios_probatorios": this.medios_probatorios,
        "observacion": this.observacion,
        "responsable": this.responsable,
        "fecha_creacion": fechaActual,
        "fecha_actualizacion": fechaActual,
        "estado": "1"
      };

      var config = {
        method: 'post',
        url: '/sap/md/mdmatriz/crear/',
        data: data
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 201) {
              this.successRegistro("Matriz");

              this.obtenerMatriz();

              this.$nextTick(() => {
                this.$refs['my-modal-matriz'].toggle('#toggle-btn')
              })
            }
          })
          .catch((error) => {
            this.errorRegistroMatriz("Matriz");
          })
          .finally(() => {
            //this.cargandoCategoria = false;
          });
    },
    editarMatriz() {

      var fechaActual = moment().format('YYYY-MM-DD H:mm:ss');

      var data = {
        "categoria": this.selectedCategoriaGuardar,
        "subcategoria": this.selectedSubCategoriaGuardar,
        "nro_articulo": this.nro_articulo,
        "articulo": this.articulo,
        "inciso": this.inciso,
        "nro_inciso": this.nro_inciso,
        "supuesto": this.supuesto,
        "estado_matriz": this.estado_matriz,
        "tipo": this.tipo,
        "tipo_sancion_1": this.selected_tipo_sancion_1,
        "cant_dias_1": this.cant_dias_1,
        "tipo_sancion_2": this.selected_tipo_sancion_2,
        "cant_dias_2": this.cant_dias_2,
        "tipo_sancion_3": this.selected_tipo_sancion_3,
        "cant_dias_3": this.cant_dias_3,
        "tipo_sancion_4": this.selected_tipo_sancion_4,
        "cant_dias_4": this.cant_dias_4,
        "medios_probatorios": this.medios_probatorios,
        "observacion": this.observacion,
        "responsable": this.responsable,
        "fecha_actualizacion": fechaActual
      };

      var config = {
        method: 'put',
        url: '/sap/md/mdmatriz/editar/' + this.matrizIdEditar,
        data: data
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.successEditado("Matriz");

              this.obtenerMatriz();

              this.$nextTick(() => {
                this.$refs['my-modal-matriz'].toggle('#toggle-btn')
              })
            }
          })
          .catch((error) => {
            this.errorEditado("Matriz");
          });
    },
    handleSubmitCategoria() {

      if (!this.checkFormValidityCategoria()) {
        return
      }

      var fechaActual = moment().format('YYYY-MM-DD');

      if (this.categoria.estado === "1") {

        const data = {
          "descripcion": this.descripcionCategoria,
        };

        //this.respuesta = await editCategoria(data, this.idCategoria);
        //var data = JSON.stringify(dataRegistrar);

        var config = {
          method: 'put',
          url: '/sap/md/categoria/editar/' + this.idCategoria,
          data: data
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                this.successEditado("Categoria");
              }
              //true;
              //console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
              this.errorEditado("Categoria");
              //false;
              //        console.log(error);
            })
            .finally(() => {
              //this.cargandoCategoria = false;
            });

      } else {
        const data = {
          "descripcion": this.descripcionCategoria,
          "fecha_creacion": fechaActual,
          "estado": "1"
        };

        //this.respuesta = await saveCategoria(data);
        const config = {
          method: 'post',
          url: '/sap/md/categoria/crear/',
          data: data
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 201) {
                this.successRegistro("Categoria");

                this.obtenerCategorias();

                this.$nextTick(() => {
                  this.$refs['my-modal-categoria'].toggle('#toggle-btn')
                })
              }
              //console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
              this.errorRegistroMatriz("Categoria");
            });
      }


    },
    checkFormValidityMatriz() {
      /*const valid = this.$refs.formMatriz.checkValidity()
      this.descripcionStateCategoria = valid
      return valid*/
    },
    handleSubmitMatriz() {

      if (!this.checkFormValidityMatriz()) {
        return
      }

      var fechaActual = moment().format('YYYY-MM-DD');



    },
    validationForm() {
      /*this.$refs.simpleRules.validate().then(success => {
          if (success) {
              // eslint-disable-next-line
              alert('form submitted!')
          }
      })*/
    },
    mostrarSubCategoriaGuardar() {
      this.optionsSubCategoriaGuardar = [];

      this.subcategorias.filter((item) => {
        if (item.categoria === this.selectedCategoriaGuardar) {
          this.optionsSubCategoriaGuardar.push({ value: item.id, text: item.descripcion });
        }
      });
    },
    mostrarSubCategoriaFiltro() {
      this.optionsSubCategoria = [];
      this.selectedSubCategoria = "TODAS";

      if (this.selectedCategoria === "TODAS") {
        this.optionsSubCategoria.push({ value: 'TODAS', text: 'TODAS' });
      } else {
        this.optionsSubCategoria.push({ value: 'TODAS', text: 'TODAS' });

        this.subcategorias.filter((item) => {
          if (item.categoria === this.selectedCategoria) {
            this.optionsSubCategoria.push({ value: item.id, text: item.descripcion });
          }
        });
      }
    },
    mostrarcant1() {
      this.disabled_cant_dias_1 = false;

      this.tipoEstado.filter((item) => {
        if (item.id === this.selected_tipo_sancion_1) {

          if (item.dias === "NO") {
            this.cant_dias_1 = 0;
            this.disabled_cant_dias_1 = true;
          }
          if (item.dias === "SI") {
            this.cant_dias_1 = "";
            this.disabled_cant_dias_1 = false;
          }
        }
      });
    },
    mostrarcant2() {
      this.disabled_cant_dias_2 = false;

      this.tipoEstado.filter((item) => {
        if (item.id === this.selected_tipo_sancion_2) {

          if (item.dias === "NO") {
            this.cant_dias_2 = 0;
            this.disabled_cant_dias_2 = true;
          }
          if (item.dias === "SI") {
            this.cant_dias_2 = "";
            this.disabled_cant_dias_2 = false;
          }
        }
      });
    },
    mostrarcant3() {
      this.disabled_cant_dias_3 = false;

      this.tipoEstado.filter((item) => {
        if (item.id === this.selected_tipo_sancion_3) {

          if (item.dias === "NO") {
            this.cant_dias_3 = 0;
            this.disabled_cant_dias_3 = true;
          }
          if (item.dias === "SI") {
            this.cant_dias_3 = "";
            this.disabled_cant_dias_3 = false;
          }
        }
      });
    },
    mostrarcant4() {
      this.disabled_cant_dias_4 = false;

      this.tipoEstado.filter((item) => {
        if (item.id === this.selected_tipo_sancion_4) {

          if (item.dias === "NO") {
            this.cant_dias_4 = 0;
            this.disabled_cant_dias_4 = true;
          }
          if (item.dias === "SI") {
            this.cant_dias_4 = "";
            this.disabled_cant_dias_4 = false;
          }
        }
      });
    },
    successRegistro(texto) {
      Swal.fire({
        title: 'Registro exitoso!',
        text: texto + ' se registro de manera satisfactoria!',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      });
    },
    errorRegistroMatriz(texto) {
      Swal.fire({
        title: 'Error!',
        text: texto + ' no se registro, la relación Categoria y Sub Categoria ya se encuentra registrada',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    successEditado(texto) {
      Swal.fire({
        title: 'Modificación exitoso!',
        text: texto + ' se modificó de manera satisfactoria!',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      });
    },
    errorEditado(texto) {
      Swal.fire({
        title: 'Error!',
        //text: texto + ' no se modificó!',
        text: texto + ' no se registro, la relación Categoria y Sub Categoria ya se encuentra registrada',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    deleteMatriz() {

      var config = {
        method: 'delete',
        url: '/sap/md/mdmatriz/eliminar/' + this.idMatrizEliminar,
      };

      axiosIns(config)
          .then((response) => {
            //console.log(JSON.stringify(response.data));
            //console.log(response);

            if (response.status === 204) {
              //console.log(response.data);

              Swal.fire(
                  'Eliminado!',
                  'Su Registro fue elimnada con éxito!',
                  'success'
              );
              this.obtenerMatriz();
            }

          })
          .catch((error) => {

            Swal.fire({
              title: 'Error!',
              text: ' No se elimino el Registro!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            //return false;
            //console.log(error);
          })
          .finally(() => {
            //this.cargandoCategoria = false;
          });






    },
    eliminarMatriz(id) {
      this.idMatrizEliminar = id;

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons.fire({
        title: 'Desea eliminar este Registro?',
        text: "No se podrá recuperar después eliminada!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminar!',
        cancelButtonText: 'No, cancelar!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

          this.deleteMatriz();

        } else if (
            result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
              'Cancelado',
              'Tu registro no se elimino!',
              'error'
          )
        }
      });

    },
    subidaMasivaMatriz() {
      this.$router.push('/matriz-subidamasiva-meddisciplinarias-page/');
    },

  },

  created() {
    this.obtenerCategorias();
    this.obtenerTipoEstado();
    this.obtenerMatriz();
    //console.log(localStorage.name);

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
